import type { EmeraldProgressBarInputs } from '@emerald-react/progress-indicator';
import { EmeraldProgressBar } from '@emerald-react/progress-indicator';

export type ProgressBarProps = EmeraldProgressBarInputs;

export function ProgressBar(props: ProgressBarProps) {
  return <EmeraldProgressBar {...props} />;
}
